import Typography from '@mui/material/Typography';
import Grid from '@mui/material/Grid';
import FormInputText from '../../../../common/Forms/FormTextField';
import CMPFormInputText from '../../../../common/Forms/CMPFormTextField';
import { useDispatch } from 'react-redux';
import {
  setDischargeGoals1,
  setDischargeGoals2,
  setDischargeObjectives1,
  setDischargeObjectives2,
  setDischargeTargetDate1,
  setDischargeTargetDate2,
} from '../../../../../redux/episode/cmpTab/cmpForm/cmpSlice';
import { CmpTitle } from '../../../../ui/styled';

const DischargePlan = (props) => {
  const dispatch = useDispatch();
  const { control, register } = props;
  return (
    <>
      <Grid item xs={12}>
        <Typography pt={2} align="center" variant='h5'>Discharge Plan Summary</Typography>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Goals</CmpTitle>
          <FormInputText
            name='dischargeGoals1'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('dischargeGoals1', {
              onBlur: (e) => dispatch(setDischargeGoals1(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Objectives</CmpTitle>
          <FormInputText
            name='dischargeObjectives1'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('dischargeObjectives1', {
              onBlur: (e) =>
                dispatch(setDischargeObjectives1(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CmpTitle variant='h6'>Projected Target Dates</CmpTitle>
          <CMPFormInputText
            name='dischargeTargetDate1'
            type='date'
            control={control}
            shrink={true}
            register={register('dischargeTargetDate1', {
              onBlur: (e) =>
                dispatch(setDischargeTargetDate1(e.target.value)),
            })}
            label='Target Date'
          />
        </Grid>
      </Grid>
      <Grid container spacing={2}>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='dischargeGoals2'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('dischargeGoals2', {
              onBlur: (e) => dispatch(setDischargeGoals2(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <FormInputText
            name='dischargeObjectives2'
            type='text'
            control={control}
            multiline={true}
            //rows={3.5}
            register={register('dischargeObjectives2', {
              onBlur: (e) =>
                dispatch(setDischargeObjectives2(e.target.value)),
            })}
          />
        </Grid>
        <Grid item xs={12} sm={4}>
          <CMPFormInputText
            name='dischargeTargetDate2'
            type='date'
            control={control}
            shrink={true}
            register={register('dischargeTargetDate2', {
              onBlur: (e) =>
                dispatch(setDischargeTargetDate2(e.target.value)),
            })}
            label='Target Date'
          />
        </Grid>
      </Grid>
    </>
  );
};

export default DischargePlan;
